import { render, staticRenderFns } from "./LaborProtectionFilter.vue?vue&type=template&id=1b4806cc&"
import script from "./LaborProtectionFilter.vue?vue&type=script&lang=ts&"
export * from "./LaborProtectionFilter.vue?vue&type=script&lang=ts&"
import style0 from "./LaborProtectionFilter.vue?vue&type=style&index=0&id=1b4806cc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports